<form [formGroup]="formGroup" class="app-section-block-layout">
  <div [class]="'app-section-block-layout__section ' + sectionClass">
    <div class="app-section-block-layout__section__header" [ngClass]="{ 'no-border': isHideBorder }">
      <div class="app-section-block-layout__section__header__left">
        <p [class]="titleClasses">
          {{ isHeaderTitleUpperCase ? (headerTitle | translate | uppercase) : (headerTitle | translate) }}
        </p>

        <app-hint-tooltip-icon *ngIf="!!infoTooltip" [hint]="infoTooltip | translate"></app-hint-tooltip-icon>
      </div>
      <div class="app-section-block-layout__section__header__right">
        <img
          *ngIf="!isShowEditBlock && isShowEditButton"
          class="app-section-block-layout__section__header__edit-icon"
          src="assets/icons/icon_edit_gray_md.svg"
          alt="edit icon"
          (click)="onEdit()"
        />
      </div>
    </div>

    <div class="app-section-block-layout__section__body">
      <ng-content select="[section-body-header]"></ng-content>

      <ng-container *ngIf="!isShowEditBlock">
        <div *ngFor="let field of visibleDisplayFields" class="app-section-block-layout__section__row">
          <p class="app-section-block-layout__section__label">
            {{ field.label | translate }}
          </p>
          <p class="app-section-block-layout__section__value" [ngClass]="{ 'text-error': !!formFieldError(field.name) }">
            <ng-container [ngSwitch]="field.type">
              <ng-container *ngSwitchCase="'date'">
                {{ getFormFieldValue(field) | customDateByUtc }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container *ngIf="field?.isShowTaggedBox">
                  {{ getFormFieldValue(field) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
                </ng-container>

                <ng-container *ngIf="!field?.isShowTaggedBox">
                  {{ getFormFieldValue(field) }}
                </ng-container>
              </ng-container>
            </ng-container>

            {{ formFieldError(field.name) | translate }}
          </p>
        </div>
        <ng-content select="[display-block-footer]"></ng-content>
      </ng-container>

      <div *ngIf="isShowEditBlock" [class]="'app-section-block-layout__edit-block ' + editBlockClass">
        <p *ngIf="!!editBlockDescription" class="app-section-block-layout__edit-block__description">
          {{ editBlockDescription | translate }}
        </p>

        <ng-content select="[edit-block-header]"></ng-content>

        <div *ngFor="let field of visibleFields" class="form-row">
          <div class="col-12">
            <div [ngSwitch]="field?.type">
              <app-control-wrapper
                *ngSwitchCase="'text'"
                [classHeader]="field?.inputClassHeader || ''"
                [control]="formGroup.get(field?.fgName || field.name)"
                [errors]="formErrors[field.name]"
                [helper]="field?.helper"
                [isShowHelper]="field?.isShowHelper"
              >
                <label *ngIf="isShowEditBlockLabel" [for]="field.name" control-label>
                  {{ field.label | translate }}
                </label>

                <div control-wrapper class="d-flex">
                  <input
                    *ngIf="isNumericInputModeeField(field)"
                    [id]="field.name"
                    class="form-control"
                    [ngClass]="{ 'has-box': field?.isShowTaggedBox }"
                    type="text"
                    [name]="field.name"
                    [formControl]="formGroup.get(field?.fgName || field.name)"
                    [placeholder]="field?.placeholder || '' | translate"
                    [pattern]="field?.pattern"
                    [patterns]="field?.patterns"
                    [inputmode]="field?.inputMode"
                    [mask]="field?.mask"
                    [validation]="field?.validation"
                    [thousandSeparator]="field?.thousandSeparator"
                    [maxMaskLength]="field?.maxMaskLength"
                    [appMaskErrorTooltip]="field?.maskErrorTooltip"
                    [maxLengthMessage]="field?.maxLengthMessage"
                    [dropSpecialCharacters]="field?.dropSpecialCharacters != null ? field?.dropSpecialCharacters : true"
                  />
                  <input
                    *ngIf="!isNumericInputModeeField(field)"
                    [id]="field.name"
                    class="form-control"
                    [ngClass]="{ 'has-box': field?.isShowTaggedBox }"
                    type="text"
                    [name]="field.name"
                    [formControl]="formGroup.get(field?.fgName || field.name)"
                    [placeholder]="field?.placeholder || '' | translate"
                    [pattern]="field?.pattern"
                    [patterns]="field?.patterns"
                    [inputmode]="field?.inputMode"
                    [mask]="field?.mask"
                    [validation]="field?.validation"
                    [maxMaskLength]="field?.maxMaskLength"
                    [appMaskErrorTooltip]="field?.maskErrorTooltip"
                    [maxLengthMessage]="field?.maxLengthMessage"
                    [dropSpecialCharacters]="field?.dropSpecialCharacters != null ? field?.dropSpecialCharacters : true"
                  />

                  <div *ngIf="field?.isShowTaggedBox" class="app-section-block-layout__input-box">
                    {{ field?.taggedBoxLabel || DEFAULT_CURRENCY_CODE }}
                  </div>
                </div>
              </app-control-wrapper>

              <app-control-wrapper
                *ngSwitchCase="'textarea'"
                [classHeader]="field?.inputClassHeader || ''"
                [control]="formGroup.get(field?.fgName || field.name)"
                [errors]="formErrors[field.name]"
                [helper]="field?.helper"
                [isShowHelper]="field?.isShowHelper"
              >
                <label *ngIf="isShowEditBlockLabel" [for]="field.name" control-label>
                  {{ field.label | translate }}
                </label>

                <button control-action-button type="button" class="btn btn-link shadow-none" (click)="field?.actionButtonClick()">
                  {{ field?.actionButtonLabel | translate }}
                </button>

                <textarea
                  control-wrapper
                  class="form-control"
                  [formControlName]="field.name"
                  [dropSpecialCharacters]="field?.dropSpecialCharacters != null ? field?.dropSpecialCharacters : true"
                  [patterns]="field?.patterns"
                  [mask]="field?.mask"
                  [appMaskErrorTooltip]="field?.maskErrorTooltip"
                  [maxLengthMessage]="field?.maxLengthMessage"
                  [maxMaskLength]="field?.maxMaskLength"
                  [rows]="field?.rows || 1"
                  (input)="field?.input()"
                ></textarea>
              </app-control-wrapper>

              <div *ngSwitchCase="'select'" [ngClass]="{ 'form-row': !!field?.comparisonLabel }">
                <div [ngClass]="{ 'col-4': !!field?.comparisonLabel }">
                  <ng-container *ngIf="isNgSelect(field); else autoSelect">
                    <app-control-wrapper
                      [classHeader]="field?.inputClassHeader || ''"
                      [control]="formGroup.get(field?.fgName || field.name)"
                      [errors]="formErrors[field.name]"
                    >
                      <label *ngIf="isShowEditBlockLabel" [for]="field.name" control-label>
                        {{ field.label | translate }}
                      </label>
                      <ng-select
                        control-wrapper
                        [id]="field?.name"
                        [formControl]="formGroup.get(field?.fgName || field.name)"
                        [bindLabel]="field?.bindLabel"
                        [bindOption]="field?.bindOption"
                        [bindValue]="field?.bindValue"
                        [updateCountCharacter]="field?.updateCountCharacter"
                        [initializeItems]="field?.initializedItems"
                        [items]="field?.items || []"
                        [fc]="formGroup.get(field?.fgName || field.name)"
                        [helper]="fieldHelper(field)"
                        [clearable]="field?.clearable != null ? field?.clearable : true"
                        [searchOnOpen]="field?.searchOnOpen"
                        [searchFn]="field?.searchFn"
                        [dropdownPosition]="field?.dropdownPosition"
                        [placeholder]="field?.placeholder || '' | translate"
                        [errors]="formErrors[field.name]"
                        [change]="field?.change"
                        (update)="!!field?.update ? field?.update($event) : null"
                      >
                        <ng-template *ngIf="!!field?.labelTemplateFieldNames" ng-label-tmp let-item="item">
                          {{ fieldsCombinedText(item, field.labelTemplateFieldNames) }}
                        </ng-template>
                        <ng-template *ngIf="!!field?.optionTemplateFieldNames" ng-option-tmp let-item="item">
                          {{ fieldsCombinedText(item, field.optionTemplateFieldNames) }}
                        </ng-template>
                      </ng-select>
                    </app-control-wrapper>
                  </ng-container>

                  <ng-template #autoSelect>
                    <auto-select
                      [id]="field?.id"
                      [label]="isShowEditBlockLabel && field.label"
                      [bindLabel]="field?.bindLabel"
                      [attr.bindOption]="field?.bindOption"
                      [bindValue]="field?.bindValue"
                      [updateCountCharacter]="field?.updateCountCharacter"
                      [initializeItems]="field?.initializedItems"
                      [items]="field?.items || []"
                      [fc]="formGroup.get(field?.fgName || field.name)"
                      [helper]="field?.helper"
                      [isShowHelper]="field?.isShowHelper"
                      [clearable]="field?.clearable != null ? field?.clearable : true"
                      [searchOnOpen]="field?.searchOnOpen"
                      [searchFn]="field?.searchFn"
                      [dropdownPosition]="field?.dropdownPosition"
                      [placeholder]="field?.placeholder || '' | translate"
                      [errors]="formErrors[field.name]"
                      [change]="field?.change"
                      (update)="!!field?.update ? field?.update($event) : null"
                    ></auto-select>
                  </ng-template>
                </div>

                <div class="col-6">
                  <div *ngIf="!!field?.comparisonValue" class="form-group">
                    <label *ngIf="!!field?.comparisonLabel">{{ field?.comparisonLabel | translate }}</label>
                    <div class="form-control border-unset control-rate">
                      {{ isNotANumber(field?.comparisonValue) ? "" : field?.comparisonValue }}
                    </div>
                  </div>
                </div>
              </div>

              <div *ngSwitchCase="'date'">
                <date-picker
                  [id]="field?.id"
                  [label]="isShowEditBlockLabel && field.label"
                  [name]="field.name"
                  [fc]="formGroup.get(field?.fgName || field.name)"
                  [helper]="field?.helper"
                  [placeholder]="field?.placeholder || ''"
                  [errors]="formErrors[field.name]"
                  [minDate]="field?.minDate"
                  [maxDate]="field?.maxDate"
                  [showCurrentDate]="field?.showCurrentDate"
                ></date-picker>
              </div>

              <div *ngSwitchCase="'checkbox'">
                <div class="custom-control custom-checkbox">
                  <input
                    [id]="field?.id"
                    type="checkbox"
                    [formControl]="formGroup.get(field?.fgName || field.name)"
                    class="custom-control-input"
                  />
                  <label *ngIf="isShowEditBlockLabel" class="custom-control-label" [for]="field?.id">
                    {{ field.label | translate }}
                  </label>
                </div>
              </div>
              <div *ngSwitchDefault></div>
            </div>
            <ng-content select="[edit-block-input-footer]"></ng-content>
          </div>
          <ng-content select="[edit-block-footer]"></ng-content>
        </div>
        <ng-content select="[edit-block-body]"></ng-content>
      </div>
    </div>
  </div>
</form>
